import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { CheckCircle2, AlertCircle, Users, TrendingUp, Target, Award } from 'lucide-react';
import { useData } from '../../context/DataContext';
import { computeReviewStatus, getWeekReview } from '../../data/mockData';
interface KPIDashboardProps {
  managerId?: string;
  rvpId?: string;
}
export function KPIDashboard({
  managerId,
  rvpId
}: KPIDashboardProps) {
  const {
    loanOfficers,
    managers,
    selectedWeek
  } = useData();
  let los = loanOfficers;
  if (managerId) {
    los = loanOfficers.filter(lo => lo.managerId === managerId);
  } else if (rvpId) {
    const rvpManagers = managers.filter(m => m.rvpId === rvpId);
    los = loanOfficers.filter(lo => rvpManagers.some(m => m.id === lo.managerId));
  }
  const totalLOs = los.length;
  const completedReviews = los.filter(lo => computeReviewStatus(getWeekReview(lo, selectedWeek)) === 'complete').length;
  const outstandingReviews = totalLOs - completedReviews;
  const avgScore = Math.round(los.reduce((acc, lo) => acc + lo.accountabilityScore, 0) / totalLOs) || 0;
  const totalApps = los.reduce((acc, lo) => acc + lo.production.applications, 0);
  const totalClosings = los.reduce((acc, lo) => acc + lo.production.closings, 0);
  const kpis = [{
    title: 'Reviews Completed',
    value: `${completedReviews}/${totalLOs}`,
    subtitle: `${Math.round(completedReviews / totalLOs * 100 || 0)}% completion`,
    icon: CheckCircle2,
    color: 'text-emerald-600',
    bg: 'bg-emerald-100'
  }, {
    title: 'Reviews Outstanding',
    value: outstandingReviews.toString(),
    subtitle: 'Action required',
    icon: AlertCircle,
    color: 'text-amber-600',
    bg: 'bg-amber-100'
  }, {
    title: 'Avg Accountability',
    value: `${avgScore}%`,
    subtitle: 'Team average score',
    icon: Award,
    color: 'text-indigo-600',
    bg: 'bg-indigo-100'
  }, {
    title: 'Total Applications',
    value: totalApps.toString(),
    subtitle: 'MTD Pipeline',
    icon: Target,
    color: 'text-blue-600',
    bg: 'bg-blue-100'
  }, {
    title: 'Total Closings',
    value: totalClosings.toString(),
    subtitle: 'MTD Funded',
    icon: TrendingUp,
    color: 'text-slate-900',
    bg: 'bg-slate-100'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-152">
      {kpis.map((kpi, i) => <Card key={i} className="border-slate-200 shadow-sm" data-id="element-153">
          <CardContent className="p-5 flex items-center space-x-4" data-id="element-154">
            <div className={`p-3 rounded-xl ${kpi.bg}`} data-id="element-155">
              <kpi.icon className={`w-6 h-6 ${kpi.color}`} data-id="element-156" />
            </div>
            <div data-id="element-157">
              <p className="text-sm font-medium text-slate-500" data-id="element-158">{kpi.title}</p>
              <h4 className="text-2xl font-bold text-slate-900" data-id="element-159">{kpi.value}</h4>
              <p className="text-xs text-slate-400 mt-0.5" data-id="element-160">{kpi.subtitle}</p>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}